import React from 'react';
import {connect} from 'react-redux';
import {postPermission} from '../../redux/actions/Permissions';

class CreatePermissionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      isEnabled: true
    };
  }

  updateComputedName(namespace, permission) {
    if (namespace && permission) {
      this.setState({
        name: namespace + ':' + permission
      });
    } else {
      this.setState({
        name: ''
      });
    }
  }

  onSubmit(e) {
    e.preventDefault();
    this.setState({
      isEnabled: false
    });
    this.props.postPermission(this.state);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });

    if (e.target.name === 'client') {
      this.updateComputedName(e.target.value, this.state.permission);
    } else if (e.target.name === 'permission') {
      this.updateComputedName(this.state.namespace, e.target.value);
    }
  }

  render() {
    return (
        <div>
          <h1>Create a permission</h1>
          <form
              onSubmit={this.onSubmit.bind(this)}
              onChange={this.onChange.bind(this)}
          >
            <div className="form-group">
              <label htmlFor="namespace">Namespace or API</label>
              <input
                  autoFocus
                  className="form-control"
                  id="namespace"
                  name="namespace"
                  required
              />
            </div>
            <div className="form-group">
              <label htmlFor="permission">Endpoint or action</label>
              <input
                  className="form-control"
                  maxLength={255}
                  id="permission"
                  name="permission"
                  required
              />
            </div>
            <div className="form-group">
              <label htmlFor="name">Permission</label>
              <small className="form-text text-muted">
                Computed as
                [<strong>Namespace</strong>]:[<strong>Endpoint</strong>]
              </small>
              <input
                  className="form-control"
                  disabled
                  id="name"
                  name="name"
                  required
                  value={this.state.name}
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <small className="form-text text-muted">
                This application (<i>the Client</i>) will be able to
              </small>
              <input
                  className="form-control"
                  id="name"
                  maxLength={255}
                  name="description"
                  required
              />
            </div>
            <button
                className="btn btn-primary"
                disabled={!this.state.isEnabled}
                type="submit"
            >
              Create
            </button>
          </form>
        </div>
    );
  }
}

const mapStateToProps = ({clients}) => ({clients});

const mapDispatchToProps = (dispatch) => {
  return {
    postPermission: ({name, description}) => {
      dispatch(postPermission(name, description));
    }
  };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreatePermissionPage);


// WEBPACK FOOTER //
// ./src/containers/CreatePermissionPage/CreatePermissionPage.js